module.exports = {
  productSettings: {
    excludeFromQuote: 'Ne pas inclure dans l\'offre',
    properties: 'Caractéristiques',
    options: 'Options',
    componentTypes: {
      chimney: {
        diameters: 'Diameters',
      },
    },
  },

  commentMode: 'Cliquez n\'importe où sur l\'écran pour ajouter un nouveau commentaire',
  comment: {
    insertPlaceholder: 'Ajouter un commentaire',
  },

  productList: {
    noProductAvailable: 'Aucun produit disponible',
  },

  productTypes: {
    solarKit: {
      piping10: 'Tuyauterie 10 mètres',
      piping15: 'Tuyauterie 15 mètres',
    },
  },

  chimneyTitle: 'Cheminée {layout}',

  categories: {
    chimney: {
      this: 'cette cheminée',
    },
  },

  addProductModal: {
    title: 'Ajouter un produit',
    categories: {
      controllers: 'Régulations',
      hydraulics: 'Hydraulique',
      chimneys: 'Cheminée',
      heatPumps: 'Pompes à chaleur',
      solarSystems: 'Systèmes solaires',
      kettle: 'Chaudières',
      boiler: 'Chauffe-eau',
    },
    categoryTitles: {
      controllers: 'Ajouter régulations',
      hydraulics: 'Ajouter hydraulique',
      chimneys: 'Ajouter cheminées',
      heatPumps: 'Ajouter pompes à chaleur',
      solarsystem: 'Ajouter systèmes solaires',
      kettle: 'Ajouter chaudières',
      boiler: 'Ajouter chauffe-eau',
    },
  },
  replaceProductModal: {
    title: 'Remplacer {product}',
  },

  removeProduct: {
    warning: {
      title: 'Supprimer {product}',
      text: 'Voulez-vous vraiment supprimer {product} de ce système ?',
    },
  },
  footer: 'C\'est une représentation des principes du système, ceci n\'est en aucun cas un schéma technique et ne tient compte d\'aucun dispositif de sécurité.',
  nextLink: 'Suivant',
};



// WEBPACK FOOTER //
// ./js/lang/fr/configurator.js